/**
 * Получает ID UP из текущего роута
 */
export const getUpIdFromRoute = (route) => {
  const id = route.params?.UPId;

  if (!id) return null;

  return parseInt(id, 10);
};